export default "__VITE_ASSET__Cg0uur8G__"